<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 18/2/2021
  -->

<template>
	<div class="qwoach-form my-5">
		<CoachingSessionsPanel
			:hideTitle="true"
			:showToast="false"
			:drawerSize="drawerSize"
			style="width: 300px;"
			ref="coachingSessions"
			v-bind="$attrs"
			:modal="false"
			mainRouteName="WizardTemplateEventType"
			backRouteName="CoachingMainCoach"
			:programItem="programItem"
			v-model="sessionType"
			:showCompletedSessions="false"
			:analytics-props="analyticsPropsMethod()"/>

	</div>
</template>

<script>
import BaseWizardStep from "@/core/components/Wizard/BaseWizardStep.vue";
import ContractProgramStep from "@shared/Program/ProgramStep/ContractProgramStep";
import CoachingSessionsPanel from "@/core/modules/coach/Coaching/Panels/CoachingSessionsPanel/CoachingSessionsPanel.vue";
import SectionProgramStep from "@shared/Program/ProgramStep/SectionProgramStep";

export default {
	name: "SetupSessionsStep",
	components: {CoachingSessionsPanel},
	extends: BaseWizardStep,

	data() {
		return {
			sessionType: null,
		}
	},

	methods:{

		stepId(){
			return "setup_sessions_step"
		},

		isStepRequired(){
			return true
		},




		async validateStep(){
			if(!this.sessionType){
				this.toastWarn("Please select a session type to proceed")
				return false
			}
			return true
		},

		async loadData(){
			console.log("SetupSessionsStep.loadData this.programItem = ", this.programItem)
			console.log("SetupSessionsStep.loadData this.wizardData = ", this.wizardData)
			if (this.programItem.sessionTypeId) {
				this.sessionType = await this.$dataManager.apiGetEventType({sessionTypeId: this.programItem.sessionTypeId, coachId: this.getCoachId()})
			}
		},

		// async validateStep(){
		// 	if(!this.docSignDocument){
		// 		this.toastInfo("Please choose an agreement to proceed or press 'skip'")
		// 		return false
		// 	}
		// 	return true
		// },

		async syncNumberOfSectionsWithSessionLimit(){
			let sessionsLimit = Math.min(15, this.programItem.sessionsLimit)
			console.log("syncNumberOfSectionsWithSessionLimit: ", sessionsLimit)
			let programSteps = this.programItem.programSteps
			let numberOfSessionSections = programSteps.length - 1
			if (numberOfSessionSections !== sessionsLimit){
				programSteps.splice(1)
				console.log("syncNumberOfSectionsWithSessionLimit: programSteps.splice(1).length = " + programSteps.length)
				for(let i = 0; i < sessionsLimit; ++i){
					programSteps.push(new SectionProgramStep("Session " + (i + 1)))
				}
			}
		},

		async onNextClicked(){
			await this.syncNumberOfSectionsWithSessionLimit()
			await this.$dataManager.updateProgram(this.programItem)
		},

		async onSkipClicked(){
		},

		stepDescription(){
			let description = ""
			this.sessionType ? description += this.sessionType.displayName + "\n" : ""
			description += this.programItem.sessionsLimit + " sessions"
			return description
		},

	},

	computed:{
		programItem(){
			return this.getWizardDataByStepId("create_program_step")
		},
		agreementRow(){
			let agreementRow
			this.programItem.findStep(step => step.isTypeContract(), step => agreementRow = step)
			if(!agreementRow){
				agreementRow = new ContractProgramStep()
				let section = this.programItem.programSteps[0]
				section.addProgramStep(agreementRow)
			}
			return agreementRow
		},

		drawerSize(){
			let res = window.outerWidth - 400
			res = res + "px"
			console.log("window.outerWidth = ", res)
			return res
		}
	}
}
</script>

<style lang="scss">

</style>
